import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

export default function PaymentSection({
  setStripe,
  setStripeElements,
  paymentMethodOrder,
}) {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => { setStripe(stripe); }, [stripe, setStripe]);
  useEffect(() => { setStripeElements(elements); }, [elements, setStripeElements]);

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Zahlungsart
      </Typography>
      <PaymentElement id="payment-element" options={{ layout: 'accordion', paymentMethodOrder }} />
    </div>
  );
}
